module.exports = __webpack_public_path__ + "img/other_pic03.ce35d8da.png";